/**
 * 上传本地图片到通用接口，返回相对路径（如 /profile/upload/...）。
 * 不要手动设置 multipart Content-Type，否则缺少 boundary 会导致上传失败。
 */
import axios from 'axios'
import { getToken } from '@/utils/auth'
import api from '@/utils/api'

function toRelativePath (url) {
  if (!url) return ''
  let raw = String(url).trim()
  if (!raw) return ''
  // 完整 URL → 只留 path
  try {
    if (/^https?:\/\//i.test(raw)) {
      const u = new URL(raw)
      raw = u.pathname + (u.search || '')
    }
  } catch (e) { /* ignore */ }
  if (!raw.startsWith('/')) raw = '/' + raw
  return raw
}

export function uploadLocalImage (file, options = {}) {
  if (!file) {
    return Promise.reject(new Error('请选择图片'))
  }
  if (file.type && !file.type.startsWith('image/')) {
    return Promise.reject(new Error('请选择图片文件'))
  }
  const maxMb = options.maxMb || 8
  if (file.size > maxMb * 1024 * 1024) {
    return Promise.reject(new Error('图片不能超过 ' + maxMb + 'MB'))
  }

  const fd = new FormData()
  fd.append('file', file)

  return axios.post(api.uploadFileUrl, fd, {
    headers: {
      authorization: 'Bearer ' + getToken()
      // 故意不设 Content-Type，让浏览器自动带 boundary
    },
    timeout: 60000
  }).then(res => {
    const body = res.data || {}
    if (body.code !== 200) {
      return Promise.reject(new Error(body.msg || '上传失败'))
    }
    const url = body.url || body.fileName || (body.data && (body.data.url || body.data.fileName))
    if (!url) {
      return Promise.reject(new Error('上传成功但未返回地址'))
    }
    // 优先相对路径 fileName；url 可能是带域名的完整地址
    const path = toRelativePath(body.fileName || url)
    return path || toRelativePath(url)
  })
}

export default uploadLocalImage



// WEBPACK FOOTER //
// ./src/utils/uploadImage.js